import { Box } from '@material-ui/core';
import React, { FC } from 'react';
import { FieldTextInput } from '../../components';
import Heading from './Heading';
import { ListingFlowFormField } from './ListingFlowTypes';
import { useCurrentUserPermissions } from '../../hooks/useUserPermissions';

const InternalBrandNotes: FC = () => {
  const { isBrand } = useCurrentUserPermissions();
  if (!isBrand) return null;

  const placeholder = 'Include any notes for internal use';

  return (
    <>
      <Heading>Internal Brand Notes (not seen by users)</Heading>
      <Box pt={1}>
        <FieldTextInput
          key={ListingFlowFormField.InternalBrandNotes}
          id={ListingFlowFormField.InternalBrandNotes}
          name={ListingFlowFormField.InternalBrandNotes}
          type="textarea"
          placeholder={placeholder}
        />
      </Box>
    </>
  );
};

export default InternalBrandNotes;
